import { PostScheduleValidation } from 'api/post';

export const getValidationMessagesCount = (
  messages?: PostScheduleValidation['messages'],
): number => {
  const { errors, warnings } = messages ?? {
    errors: [],
    warnings: [],
  };

  return (errors.length ?? 0) + (warnings.length ?? 0);
};
